<template>
  <div id="AddBlog">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="formAdd">
    <v-container class="-border">
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" :href="'#/blog'">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex class="xs12 sm6">
          <v-text-field label="Blog Title" v-model.trim ="newBlog.title" class="required pr-4 pl-4" :rules="formRules.title" @input="changedData" id="addBlogSteps1"></v-text-field>
        </v-flex>
        <v-flex class="xs12 sm6">
          <!-- <v-select label="Status" @change="changedData" v-model="newBlog.status" :items="statuses" class="pr-4 pl-4 required"></v-select> -->
        </v-flex>
        <v-layout wrap pl-2 pr-2>
          <v-flex class="xs12 sm6 pl-4 pf-sub-head custom-title" wrap>Blog Content
            <v-tooltip right>
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon small>
                <v-icon size="22" >info</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Add blog content below</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <v-flex class="xs12">
          <div id="blogTextEditor" >
            <v-container grid-list-xl fluid pt-0>
              <v-layout row wrap>
                <v-flex sm12 id="addBlogSteps2">
                  <v-layout class="flex-row flex-space-between mb-2 ml-1 mr-1">
                    <div class="pf-font-14 pf-text-teal flex-start pf-width-100p">Maximum number of words: {{ BlogSettings.word_count ? BlogSettings.word_count : 1500 }}</div>
                    <div class="pf-font-14 flex-end pf-width-100p" :class="{ 'pf-text-red': currentWordCount > (BlogSettings.word_count || 1500), 'pf-text-teal': currentWordCount <= (BlogSettings.word_count || 1500) }">Number of words: {{ currentWordCount }}</div>
                  </v-layout>
                  <editor :options="editorOption" :rules="formRules.title" :content="content" :init="init" :api-key="apikey" v-model="newBlog.content" @onKeyUp="changedData" @onPaste="changedData" />
                  <!-- <ejs-richtexteditor :height="ejsHeight" :rules="formRules.title" :content="content" :change="changedData" ref="rteObj" placeholder="Add blog content here.." :insertImageSettings="insertImageSettings" v-model="newBlog.content"></ejs-richtexteditor> -->
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-flex>
        <!-- <v-layout wrap pl-2 pr-2>
          <v-flex class="xs12 sm6 pl-4 pf-sub-head custom-title" wrap>Blog Description
            <v-tooltip right>
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon small>
                <v-icon size="22" >info</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Add Blog description here</span>
            </v-tooltip>
          </v-flex>
        </v-layout> -->
        <!-- <v-flex class="xs12">
          <div class="blogTextEditorShort" >
            <v-container grid-list-xl fluid pt-0>
              <v-layout row wrap>
                <v-flex sm12>
                  <editor :options="editorOption.shortDescription" :content="content" :init="initmeta" :api-key="apikey" v-model="newBlog.excerpt" @input="changedData" />
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-flex> -->
        <!-- <v-flex class="xs12 sm6">
          <v-combobox class="pr-4 pl-4" @change="changedData" v-model="newBlog.categories" :items="BlogCategory" label="Categories - hit enter to add or choose from most used" @keyup.enter="addCategory" multiple deletable-chips small-chips></v-combobox>
        </v-flex> -->
        <v-flex class="xs12 sm6">
          <v-select class="pr-4 pl-4" @change="changedData" v-model="newBlog.tags" :items="BlogSettings.tags" label="Tags - choose from the list" id="addBlogSteps3" multiple deletable-chips small-chips no-data-text="No tags available"></v-select>
        </v-flex>
      </v-layout>

      <!-- <v-layout wrap class="mt-4">
        <v-flex xs12 sm12 class="pr-4 pl-4">
          <h5 class="text-uppercase font-weight-bold">Search Engine Options</h5>
        </v-flex>
        <v-flex class="xs12 sm6">
          <v-text-field label="Title" v-model="newBlog.seo.title" class="pr-4 pl-4" @input="changedData"></v-text-field>
        </v-flex>
        <v-flex class="xs12 sm6">
          <v-text-field label="Slug" v-model="getBlogSlug" class="pr-4 pl-4" @input="changedData"></v-text-field>
        </v-flex>
        <v-flex class="xs12 sm6">
          <v-combobox class="pr-4 pl-4" @change="changedData" v-model="newBlog.seo.keywords" :items="keywords" label="Keywords - hit enter to add new" @keyup.enter="addKeyword" multiple deletable-chips small-chips></v-combobox>
        </v-flex>
        <v-flex class="xs12">
          <div class="blogTextEditorShort" >
            <v-container grid-list-xl fluid>
              <v-layout row wrap>
                <v-flex sm12>
                  <editor :options="editorOption.metaDescription" :content="content" :init="initmeta" :api-key="apikey" v-model="newBlog.seo.metaDescription" @input="changedData" />
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-flex>
      </v-layout> -->
      <v-layout>
      </v-layout>
      <!-- image add seciton starting-->
      <v-layout wrap pl-2 pr-2>
        <v-flex class="xs12 sm6 md7 pl-4 pt-4 pf-sub-head mb-3 custom-title" wrap>Featured Image
          <v-tooltip top>
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn
                  class="pf-btn-text-white pf-bg-green"
                  @click="addBlogImage()"
                  id="addBlogSteps4"
                >
                  Upload
                  <v-icon size="22" class="ml-2">camera_alt</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Add new image</span>
            </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- image add seciton ending-->
      <!-- image show div start-->
        <v-layout wrap class="mt-4 imageDiv" pl-2 pr-2>
          <v-flex xs12 sm6 md4 pl-4>
            <v-card falt tile v-if="blogImageUrl">
            <v-layout class="wrap pt-1 pr-1 xs12 text-xs-center">
              <v-flex xs12 pl-1>
                <div>
                  <img
                  :src="blogImageUrl"
                  :lazy-src="blogImageUrl"
                  width="100%"
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-card>
          </v-flex>
        </v-layout>
        <!-- image show div end-->
    </v-container>
    <v-container class="pt-4">
      <v-layout>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" :href="'#/blog'">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    </v-form>
    <v-tour v-if="isNewVisit" :callbacks="addBlogGuideCallbacks" :class="{ 'pf-no-display': tourHidden || !isNewVisit || blogList.length }" name="addBlogGuide" :steps="addBlogSteps" :options="addBlogGuideOptions"></v-tour>
  </div>
</template>

<script>
/* global session router config store */
/* eslint max-depth: [2, 6] */
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Editor from '@tinymce/tinymce-vue';
import { create, /* stringToSlug, checkWPToken, requestToWPPF, */ getCookie, setCookie, sortList, getCollection, updateSortList, uploadFile } from '../../helpers/helpers';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';

import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-vue-richtexteditor/styles/material.css';

import Vue from 'vue';
import { RichTextEditorPlugin, Toolbar, Image,  Link, HtmlEditor, QuickToolbar, NodeSelection } from '@syncfusion/ej2-vue-richtexteditor';
Vue.use(RichTextEditorPlugin);


// To add new blogs by parent or agency
export default {
  name: 'AddBlog',
  components: {
    'editor': Editor
  },
  data: (vm) => ({
    entity: 'Blog',
    roleEntity: 'Account',
    config: config,
    editorOption: {
      'initial-value': 'Add text here..',
      metaDescription: {
        placeholder: 'Add meta description here..'
      },
      shortDescription: {
        placeholder: 'Add pm2short description here..'
      }
    },
    apikey: config.tinymceEditorKey,
    init: {
      height: 500,
      selector: 'blogTextEditor',
      paste_data_images: true,
      file_picker_types: 'image',
      images_upload_handler: function (blobInfo, success, failure) {
        let postUrl = 'File';
        let extraParams = {
          type: 'Blog'
        };
        extraParams[vm.roleEntity.toLowerCase()] = session.user().human[vm.roleEntity.toLowerCase()].id;

        uploadFile(postUrl, blobInfo.blob(), 'POST', extraParams)
          .then(function (res) {
            success(config.uploadPath + res.$data.webPath);
          })
          .catch(function (err) {
            failure('HTTP Error: ' + err.message);
          });
      },
      menubar: true,
      plugins: ['advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount emoticons'],
      toolbar:
           'undo redo | bold italic backcolor | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | forecolor backcolor removeformat | pagebreak | charmap emoticons | preview | insertfile image media template link anchor codesample | ltr rtl'
    },
    initmeta: {
      height: 200,
      menubar: false,
      plugins: ['wordcount emoticons'],
      toolbar:
           'undo redo | bold italic backcolor | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | forecolor backcolor removeformat | charmap emoticons | link anchor | ltr rtl'
    },
    value: [
      { name: 'Javascript', code: 'js' }
    ],
    /* statuses: [{ text: 'Publish', value: 'publish' },
      { text: 'Draft', value: 'draft' },
      { text: 'Pending', value: 'pending' },
      { text: 'Private', value: 'private' } 
    ], */
     
    // keywords: [],
    formRules: {
      title: [v => !!v || 'Blog title is required'],
      content: [v => !!v || 'Blog content is required'],
    },
    content: '',
    currentWordCount: 0,
    selectedData: false,
    newBlog: {
      title: '',
      content: '',
      image: {
        filename: '',
        thumb_url: '',
        webview_url: '',
        original_url: '',
        s3: true
      },
      excerpt: '',
      categories: ['Adoption Profile Update'],
      tags: [],
      featuredImage: 'This is not yet finalized',
      status: 'publish',
      // visibility: 'Public',
      seo: {
        keywords: [],
        title: '',
        slug: '',
        metaDescription: '',
      }
    },
    rules: {
      required: value => !!value || 'Field is required.',
    },
    error: '',
    blogImageUrl: '',
    addBlogSteps: [
      {
        target: '#addBlogSteps1',
        header: {
          title: 'Blog Title'
        },
        content: 'Add your blog title here'
      },
      {
        target: '#addBlogSteps2',
        header: {
          title: 'Blog Content'
        },
        content: 'Your blog content goes here, It should not exceed the given number of words'
      },
      {
        target: '#addBlogSteps3',
        header: {
          title: 'Blog Tags'
        },
        content: 'Select the tags for your blog here'
      },
      {
        target: '#addBlogSteps4',
        header: {
          title: 'Blog Image'
        },
        content: 'You can upload the featured image for your blog here'
      }
    ],
    addBlogGuideCallbacks: {
      onFinish: vm.guideVisited,
      onSkip: vm.guideVisited
    },
    addBlogGuideOptions: {
      highlight: true
    },
    tourHidden: false
  }),
  provide: {
    richtexteditor: [Toolbar, Image, Link, HtmlEditor, QuickToolbar]
  },
  computed: {
    ...mapGetters(['Blog', 'Account', 'Agency', 'Child']),
    
    blogList: {
      get () {
        return store.state.Blog;
      },
      set (value) {
        if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
          updateSortList(this.entity, value, 'Agency', session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        } else {
          updateSortList(this.entity, value, this.roleEntity, session.getSession().adminUser ? session.getSession().user.human[this.roleEntity.toLowerCase()].id : 'Me');
        }
        store.commit('setBlog', value);
      }
    },

    /* getBlogSlug: {
      get () {
        return stringToSlug(this.newBlog.title);
      },
      set (value) {
        this.newBlog.seo.slug = value;
      }
    }, */
    /* BlogCategory: {
      get () {
        return store.state.BlogCategory;
      },
      set (value) {
        store.commit('setBlogCategory', value);
      }
    }, */
    BlogSettings: {
      get () {
        return store.state.BlogSettings;
      },
      set (value) {
        store.commit('setBlogSettings', value);
      }
    },
    isNewVisit () {
      return !getCookie('pf.blog.add');
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.roleEntity = session.role() === 'child' ? 'Child' : this.roleEntity;
    this.feedSelects();
    this.initialize();
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
    /* Start the tour only if new visitor and no blogs exists before */
    if (this.isNewVisit && !this.blogList.length && !session.getSession().adminUser) {
      this.$tours['addBlogGuide'].start();
    } else {
      this.tourHidden = true;
    }
  },
  methods: {
    // @vuese
    // Used to fetch the blog list if no exists.
    async initialize () {
      if (!this.blogList.length) {
        let sessionUser = session.getSession();
        let where = {};
        if (sessionUser.adminUser) {
          if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
            where.agency = sessionUser.user.human.agency;
          } else {
            where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
          }
        }
        let { error, data } = await getCollection(this.entity, true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
              this.blogList = sortList(this.entity, data, 'Agency', sessionUser.adminUser ? sessionUser.user.human.agency : 'Me');
            } else {
              this.blogList = sortList(this.entity, data, this.roleEntity, sessionUser.adminUser ? sessionUser.user.human[this.roleEntity.toLowerCase()].id : 'Me');
            }
          }
        }
      }
    },
    // @vuese
    // Used to fetch blog categories and tags from wordpress.
    async feedSelects () {
      if (!Object.keys(this.BlogSettings).length) {
        let where = {
          '$or': [{ is_super_admin: true }]
        };
        if (this[this.roleEntity].default_agency) {
          where['$or'].push({ _id: this[this.roleEntity].default_agency });
        }
        let attributes = 'blog_settings,is_super_admin';
        let { error, data } = await getCollection('Agency', true, 0, '', where, attributes);
        if (error) {
          console.log(error);
        } else {
          /* Get the settings from admin by default */
          let adminIndex = data.findIndex(x => x.is_super_admin);
          let blogSettings = {};
          if (adminIndex > -1 && data[adminIndex].blog_settings && Object.keys(data[adminIndex].blog_settings).length) {
            blogSettings.word_count = data[adminIndex].blog_settings.word_count ? data[adminIndex].blog_settings.word_count : 1500;
            blogSettings.tags = data[adminIndex].blog_settings.tags ? data[adminIndex].blog_settings.tags : [];
          } else {
            /* Set a default value */
            blogSettings = {
              word_count: 1500,
              tags: []
            };
          }
          /* Overwrite the word count if set by agency */
          let defaultAgencyIndex = data.findIndex(x => x.id === this[this.roleEntity].default_agency);
          if (defaultAgencyIndex > -1 && data[defaultAgencyIndex].blog_settings && data[defaultAgencyIndex].blog_settings.word_count) {
            blogSettings.word_count = data[defaultAgencyIndex].blog_settings.word_count ? data[defaultAgencyIndex].blog_settings.word_count : blogSettings.word_count;
          }
          this.BlogSettings = blogSettings;
        }
      }
    },
    // @vuese
    // Used to add a new category
    /* addCategory () {
      this.BlogCategory = [...this.BlogCategory, ...this.newBlog.categories];
    }, */
    // @vuese
    // Used to add a new tag
    addTag () {
      this.BlogSettings.tags = [...this.BlogSettings.tags, ...this.newBlog.tags];
    },
    guideVisited () {
      /* Set the addBlogGuide cookie */
      setCookie('pf.blog.add', true, 365);
      this.tourHidden = true;
    },
    // @vuese
    // Used to add a new seo keyword
    /* addKeyword () {
      this.keywords = [...this.keywords, ...this.newBlog.seo.keywords];
    }, */
    // @vuese
    // Used to go back to the blog listing page
    backToListing () {
      this.$router.push({ path: '/blog' });
    },
    // @vuese
    // Used to show the buttons on any change in the form.
    changedData (event, editor) {
      this.selectedData = true;

      /* Update the word count if blog content */
      if (editor && editor.plugins && editor.plugins.wordcount) {
        this.currentWordCount = editor.plugins.wordcount.body.getWordCount();
      }
    },
    // @vuese
    // Used to hide the form buttons.
    hideButtons () {
      this.selectedData = false;
    },
    // @vuese
    // Used to save the blog.
    async save () {
      this.selectedData = false;
      if (!this.newBlog.title.length) {
        this.selectedData = true;
        swal.fire({
          type: 'warning',
          title: 'Title is required.',
          text: 'Please add title before saving!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;

      } else if (!this.newBlog.content.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
        swal.fire({
          type: 'warning',
          title: 'Content is required.',
          text: 'Please add the blog content to save',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
          onClose: () => {
            this.selectedData = true;
          }
        });
      } else if (this.currentWordCount > (this.BlogSettings.word_count || 1500)) {
        swal.fire({
          type: 'warning',
          title: 'Content is too lengthy.',
          text: `The blog content should not exceed ${(this.BlogSettings.word_count || 1500)} words`,
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
          onClose: () => {
            this.selectedData = true;
          }
        });
        return;
      } else {
        if (this.$refs.formAdd.validate()) {
          this.selectedData = false;
          if (session.getSession().adminUser) {
            if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
              this.newBlog.agency = session.getSession().user.human.agency;
            } else {
              this.newBlog[this.roleEntity.toLowerCase()] = session.getSession().user.human[this.roleEntity.toLowerCase()].id;
            }
          }
          if (this.newBlog.image.original_url) {
            this.newBlog.image.thumb_url = this.newBlog.image.original_url.replace(/original/gi, 'thumb');
            this.newBlog.image.webview_url = this.newBlog.image.original_url.replace(/original/gi, 'webview');
          } else {
            delete this.newBlog.image;
          }
          if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
            this.newBlog.user_mapping_id = this.Agency.mapping_id;
          } else {
            this.newBlog.user_mapping_id = this[this.roleEntity].mapping_id;
          }
          let { error, data, status } = await create('Blog', this.newBlog);
          if (error) {
            console.log('error', error);
            this.selectedData = true;
          } else {
            this.loading = false;
            this.Blog.unshift(data);
            let blogItem = {
              sort_no: 0,
              blog: data.id
            };
            if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
              this.Agency.blog.unshift(blogItem);
            } else {
              this[this.roleEntity].blog.unshift(blogItem);
            }
            let alert = data.approved ? 'Blog added successfully' : 'Blog was submitted for review';
            swal.fire({
              type: 'success',
              title: alert,
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.$router.push({ path: '/blog' });
              }
            });
          }
        } else {
          this.selectedData = true;
        }
      }
    },
    addBlogImage () {
      const client = global.filestack.init(config.filestack.client);
      const humanId = session.user().human.id;
      const options = {
        fromSources: ['local_file_system'],
        maxFiles: 1,
        accept: ['image/*'],
        uploadInBackground: false,
        transformations: {
          crop: { aspectRatio: 300 / 228 }
        },
        storeTo: {
          location: 'S3',
          path: '/' + config.s3Domain + '/' + humanId + '/blogs/images/original/',
          access: 'public'
        },
        onFileSelected (file) {
          let filenameArr = file.filename.split('.');
          let ext = filenameArr.pop();
          let filename = filenameArr.join('.');
          filename = filename.replace(/[^0-9a-z]/gi, '');
          return { name: filename + '_' + (new Date().getTime()) + '.' + ext };
        },
        onUploadDone: (response) => {
          console.log(response);
          this.selectedData = true;
          let fileName = response.filesUploaded[0].key.split('/');
          this.newBlog.image.filename = fileName[fileName.length - 1];
          this.blogImageUrl = response.filesUploaded[0].url;
          this.newBlog.image.original_url = response.filesUploaded[0].key;
          swal.fire({
            type: 'success',
            title: 'Blog image uploaded successfully',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
        }
      };
      client.picker(options).open();
    }
  }
};
</script>
<style scoped>

.letrimmgbtns {
  display: flex;
  justify-content: flex-end;
}

#AddBlog >>> .e-richtexteditor .e-rte-toolbar {
  z-index: auto !important;
}

#AddBlog >>> .e-linkheader, #AddBlog >>> .imgUrl {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Blog/add.vue